import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { Box, Icon, Typography } from 'shared/ui'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { EnrolmentStep } from 'widgets/ContactEnrollment'
import { AgentFooterButtons } from 'pages/chatbot/ui'
import { useChatbotContext } from 'pages/chatbot/context'
import { useBookAppointmentBlocker } from 'pages/chatbot/pages/agentBookAppointment/hooks/useBookAppointmentBlocker'
import styles from './styles.module.scss'

export const AgentActivate = observer(() => {
  const chatbotStore = useChatbotContext()
  const { agentId: id } = useParams()
  const {
    agentBookAppointmentStepsStore: {
      agentActivateStore,
      isExistChanges,
      confirmLeavePage,
      decreaseStep,
    },
    model: { isActive },
  } = chatbotStore
  const {
    enrollmentFilters,
    enrollmentStore: {
      isContactReEnroll,
      setIsContactReEnroll,
      isShowContactsAlert,
      setIsShowContactsAlert,
    },
    editEnrollment,
    numberStore,
    errorsMap,
    isLoading,
    removeError,
    handleSaveDraft,
    showRcsEmptyFallbackInboxAlert,
    handleActivateClickWithModal,
  } = agentActivateStore

  const filtersError = errorsMap.get('filters')
  const sendFromError = errorsMap.get('send_from')

  useBookAppointmentBlocker({
    isExistChanges,
    confirmLeavePage: (blocker) =>
      confirmLeavePage(
        blocker,
        id,
        isActive
          ? async (id) => {
              const result = await handleActivateClickWithModal(id, {
                isPublished: isActive,
                shouldRedirect: false,
              })
              return result
            }
          : handleSaveDraft
      ),
  })

  const onClick = () => {
    if (isLoading) return
    removeError('filters')
    editEnrollment()
  }
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      height={'100%'}
      justifyContent={'space-between'}
      paddingLeft={'20px'}
      paddingRight={'20px'}
    >
      <div className={styles.contentWrapper}>
        <Typography
          ariaLabel='AgentActivate_title'
          variant='heading-sm'
          marginBottom={32}
          marginTop={32}
        >
          How to use your Agent
        </Typography>
        <Typography ariaLabel='AgenOnDemand' variant='body-lg-medium' marginBottom={4}>
          Use the Agent on demand
        </Typography>
        <Typography
          ariaLabel='AgenDescription'
          variant='body-md-regular'
          color='var(--content-primary-secondary)'
          marginBottom={16}
        >
          Your agent is ready. Once activated, you can start it from:
        </Typography>
        <div className={styles.checkboxBlock}>
          {['CRM Workflows', 'Conversations', 'Contacts Page'].map((item, index) => (
            <div className={styles.checkboxItem} key={index}>
              <Icon icon='check2Correct' color='var(--green-60)' />
              <Typography ariaLabel='CheckboxItem_title' variant='body-rg-regular'>
                {item}
              </Typography>
            </div>
          ))}
        </div>
        <Typography ariaLabel='AutomatedEnrollment' variant='body-lg-medium'>
          Automated enrollment (optional)
        </Typography>
        <Typography
          ariaLabel='AutomatedEnrollmentDescription'
          variant='body-md-regular'
          color='var(--content-primary-secondary)'
          marginBottom={12}
          marginTop={4}
        >
          Automated triggers won’t affect on-demand use. You can start the agent manually anytime
        </Typography>
        <EnrolmentStep
          enrollmentFilters={enrollmentFilters}
          error={filtersError}
          removeError={() => removeError('send_from')}
          numberError={sendFromError}
          onClick={onClick}
          title='Contact enrollment'
          numberStore={numberStore}
          dropdownWidth={424}
          rightActions={[makeTextFieldIcon({ icon: 'chevronDown', fontSize: 18 })]}
          contactReEnroll={{
            value: isContactReEnroll,
            onChange: setIsContactReEnroll,
            isShowAlert: isShowContactsAlert,
            onCloseAlert: () => setIsShowContactsAlert(false),
            showRcsEmptyFallbackInboxAlert: showRcsEmptyFallbackInboxAlert,
          }}
        />
      </div>
      <AgentFooterButtons className={styles.footerButtons} isLastStep decreaseStep={decreaseStep} />
    </Box>
  )
})
